import { Component, Input, inject } from "@angular/core";
import { ViewService } from "core/view.service";
import { Observable } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { PropertiesComponent } from "./properties.component";

@Component({
	selector: "stages-process-element-properties-wrapper",
	templateUrl: "./properties-wrapper.component.html",
	imports: [PropertiesComponent, AsyncPipe],
})
export class PropertiesWrapperComponent {
	private viewService = inject(ViewService);

	// TODO: Skipped for migration because:
	//  Your application code writes to the input. This prevents migration.
	@Input() translateNone?: string;
	// TODO: Skipped for migration because:
	//  Your application code writes to the input. This prevents migration.
	@Input() propertyList?: unknown;

	selfElement$: Observable<stages.process.ProcessTreeItem>;

	constructor() {
		this.selfElement$ = this.viewService.awaitSelfElementObservable();
	}
}
